"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var repositoryAdmin;
        (function (repositoryAdmin) {
            var createOrEdit;
            (function (createOrEdit) {
                function init() {
                    appn.select.init({
                        selector: 'select#iconsToDisplay',
                        isIconSelect: true
                    });
                    $('#Item_InstallTags').select2({
                        tags: true,
                        theme: 'bootstrap4'
                    });
                }
                createOrEdit.init = init;
            })(createOrEdit = repositoryAdmin.createOrEdit || (repositoryAdmin.createOrEdit = {}));
        })(repositoryAdmin = views.repositoryAdmin || (views.repositoryAdmin = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
